import { useCallback } from 'react';
import { useInstantSearch, useMenu } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

import { useSearchDictionary } from '../util';

export interface filter {
  value: string;
  label: string;
}
export interface IMyProps {
  filters: string[];
}

const TypeFacet = ({ filters }: IMyProps) => {
  const dict = useSearchDictionary();

  const { indexUiState } = useInstantSearch();

  const selectedType = indexUiState.menu?.type || '';

  let { items } = useMenu({
    attribute: 'type',
  });

  const { refine } = useMenu({
    attribute: 'type',
  });

  const filterstring = filters.join().toLowerCase();

  // If filters are specified then map types to include them
  if (filters?.length > 0) {
    items = items.filter((item) => {
      return filterstring.includes(item.value);
    });
  }

  const getDictionaryTypeValue = (category: string) => {
    switch (category) {
      case 'article':
        return dict.articleType;
      case 'event':
        return dict.eventType;
      case 'file':
        return dict.fileCategoryType;
      case 'employee':
        return dict.employeeType;
      case 'other':
        return dict.otherType;
      case '':
        return dict.allResult;
      default:
        return category;
    }
  };
  const handleTypeSelect = useCallback(
    (type: string) => {
      refine(type);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedType]
  );

  const options = [{ value: '', label: dict.allResult }, ...items];
  return (
    <div
      className={classnames(
        'mb-4',
        'flex',
        'w-full',
        'justify-between',
        'items-center',
        'mb-4',
        'sm:mb-0'
      )}
    >
      <div
        className={classnames('text-blue-navy', 'heading-sm', 'mr-6', 'min-w-[50px]', 'lg:min-w-0')}
      >
        Topic
      </div>
      <select
        className={classnames('border', 'border-gray-spunPearl', 'rounded-md', 'p-2', 'w-full')}
        value={selectedType}
        title="Topic"
        onChange={(e) => handleTypeSelect(e.currentTarget.value)}
      >
        {options.map((x) => (
          <option key={x.value} value={x.value}>
            {getDictionaryTypeValue(x.value)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TypeFacet;
